import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { takeUntil } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';

import { AuthenticationService, AlertService } from '@core/startup';
import { MessageService } from '@core/shared/services/message.service';
import { LoginType, RequestType } from '@core/common/constants.service';
import { SystemSettings } from '@core/models'
import { PreloginService } from '@core/prelogin/services/prelogin.service';
import { environment } from '@env/environment';
import * as fromStore from '@core/store';
import { Subject } from 'rxjs';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: [
        './login.component.scss'
    ]
})
export class LoginComponent implements OnInit, OnDestroy {

    public formLogin: FormGroup;
    public referenceID: any;
    public timerFlag: boolean = false;
    public isResendOTP: boolean = false;
    public isPasswordEnabled: boolean = true;
    public isOTPEnabled: boolean = false;
    public loginTypes: any = LoginType.loginTypes;
    public label: string = 'ParticipantLogin.Username';
    public validationError: string = 'ParticipantLogin.UsernameRequired';
    public passwordLable: string = 'ParticipantLogin.Password'
    public passwordErrorMessage: string = 'ParticipantLogin.PasswordRequired';
    public expiryTime: string;
    public expiryMinutes: any;
    public expirySeconds: any;
    public isSelfRegistrationRequired: any;
    public isSelfRegistrationEnabled: boolean = false;
    public disableUserName: boolean = true;
    isSubmitted: boolean;
    private onDestroy$ = new Subject<void>();
    isAuthenticated: boolean;
    loginTitle = '';

    constructor(
        public fb: FormBuilder,
        public router: Router,
        public authenticationService: AuthenticationService,
        public alertService: AlertService,
        private messageService: MessageService,
        public translate: TranslateService,
        public systemSettings: SystemSettings,
        public PreloginService: PreloginService,
        private store: Store<fromStore.PlatformState>,
        private activeRouter: ActivatedRoute,
        public ref: ChangeDetectorRef) { }

    ngOnInit() {
        this.activeRouter.queryParams.subscribe(params => {
            if (params && params.impersonate) {
                this.impersonateLogin(params.impersonate);
            }
        });

        this.store.select(fromStore.authenticationState).pipe(takeUntil(this.onDestroy$)).subscribe(state => {
            if (state.status && !this.isAuthenticated) {
                this.isAuthenticated = state.status;
                this.router.navigate([`/home`]);
            }
        });

        this.getSelfRegistrationStatus();
        this.formLogin = this.fb.group({
            username: ['', [Validators.required]],
            password: ['', [Validators.required]],
            login: ['username'],
            otp: ['']
        });
    }

    ngAfterViewChecked() {
        var programName = sessionStorage.getItem("programName");
        var title = 'Title';
        switch (programName) {
            case 'privilegeclub':
                title = 'TitlePC';
                break;
            case 'achieversclub':
                title = 'TitleAC';
                break;
            case 'fullthrottle':
                title = 'TitleFT';
                break;
            case 'safetykings':
                title = 'TitleSK';
                break;
            case 'flyhigh':
                title = 'TitleFH';
                break;
            case 'carcarecontest':
                title = 'TitleCC';
                break;
            case 'starsofsafety':
                title = 'TitleSS';
                break;
            case 'itbrewards':
                title = 'TitleITBR';
                break;
            case 'elev8':
                title = 'TitleEL8';
                break;
            case 'rapid':
                title = 'TitleAAD';
                break;
            case 'procare':
                title = 'TitleProCare';
                break;
            case 'coc':
                title = 'TitleCOC';
                break;
            case 'bandhan':
                title = 'TitleBandhan';
                break;
            case 'eliteclubrewards':
                    title = 'TitleEliteClubRewards'
                    break;
        }
        this.loginTitle = this.translate.instant(`ParticipantLogin.${title}`)
        this.ref.detectChanges();
    }

    save(formLogin) {
        this.isSubmitted = true;
        let grantType = formLogin.value.otp ? LoginType.otpGrantType : LoginType.passwordGrantType;
        if (formLogin.valid) {
            let loginType = '';
            if (this.formLogin.value.login === LoginType.mobile) {
                loginType = 'Mobile';
            } else if (this.formLogin.value.login === LoginType.email) {
                loginType = 'Email';
            } else {
                loginType = '';
            }
            let rawLogin = this.formLogin.getRawValue();
            this.PreloginService.getUserProgramName(rawLogin.username, window.location.host, loginType).subscribe((res: any) => {
                if (res.participantProgramDetails.isAccessible) {
                    if (loginType == "Mobile") {
                        this.authenticationService.login(res.participantProgramDetails.username, rawLogin.password, 'username', grantType, this.referenceID, formLogin.value.otp
                        ).subscribe(result => {
                            this.onLoginSucceeded(result);
                        }, result => {
                            this.messageService.showError(this.translate.instant(result.error.error));
                        });
                    }
                    else if (loginType != "Mobile") {
                        this.authenticationService.login(rawLogin.username, rawLogin.password, rawLogin.login.toString(), grantType, this.referenceID, formLogin.value.otp
                        ).subscribe(result => {
                            this.onLoginSucceeded(result);
                        }, result => {
                            this.messageService.showError(this.translate.instant(result.error.error));
                        });
                    }
                } else {
                    this.messageService.showError(this.translate.instant('CustomProgram.LoginProgramValidation'));
                }
            });

        }
    }

    useOTPasPassword(event) {
        if (this.formLogin.value.username === '') {
            this.formLogin.get('otp').setValue(false);
            this.messageService.showWarning(this.translate.instant(this.validationError));
        } else if (event.target.checked) {
            this.passwordLable = 'ParticipantLogin.OTP';
            this.passwordErrorMessage = 'ParticipantLogin.OTPRequired';
            this.formLogin.get('password').setValue("");
            this.sendOTP();
        }
        else {
            this.isOTPEnabled = false;
            this.passwordLable = 'ParticipantLogin.Password';
            this.passwordErrorMessage = 'ParticipantLogin.PasswordRequired';
            this.formLogin.controls['username'].enable();
        }

    }

    sendOTP() {

        let rawLoginDetails = this.formLogin.getRawValue();
        this.isOTPEnabled = false;
        this.PreloginService.getUserProgramName(rawLoginDetails.username, window.location.host, rawLoginDetails.login).subscribe((res: any) => {
            if (res.participantProgramDetails.isAccessible) {
                if (rawLoginDetails.login == "mobile") {
                    this.authenticationService.getUserAccount(res.participantProgramDetails.username, 'username', 'Login').subscribe(response => {

                        this.authenticationService.sendOTP(RequestType.CS_Login, response.id, response.emailAddress).subscribe(response => {
                            this.referenceID = response.referenceID;
                            this.expiryTime = response.expiryTime;
                            this.isResendOTP = true;
                            this.calculateDateDifference(new Date(), new Date(response.expiryTime))
                            this.isOTPEnabled = true;
                            this.isPasswordEnabled = false;
                            this.timerFlag = true;
                            this.formLogin.controls['username'].disable();
                            this.messageService.showSuccess(this.translate.instant('ParticipantLogin.OTPSentSuccessfully'));
                        });
                    }, error => {
                        this.timerFlag = false;
                    });
                }
                else if (rawLoginDetails.login != "mobile") {
                    this.authenticationService.getUserAccount(rawLoginDetails.username, rawLoginDetails.login, 'Login').subscribe(response => {

                        this.authenticationService.sendOTP(RequestType.CS_Login, response.id, response.emailAddress).subscribe(response => {
                            this.referenceID = response.referenceID;
                            this.expiryTime = response.expiryTime;
                            this.isResendOTP = true;
                            this.calculateDateDifference(new Date(), new Date(response.expiryTime))
                            this.isOTPEnabled = true;
                            this.isPasswordEnabled = false;
                            this.timerFlag = true;
                            this.formLogin.controls['username'].disable();
                            this.messageService.showSuccess(this.translate.instant('ParticipantLogin.OTPSentSuccessfully'));
                        });
                    }, error => {
                        this.timerFlag = false;
                    });
                }
            }
        });
    }

    changeLable() {
        this.label = this.formLogin.value.login === LoginType.mobile ? 'ParticipantLogin.MobileNo'
            : (this.formLogin.value.login === LoginType.email ? 'ParticipantLogin.EmailId'
                : (this.formLogin.value.login === LoginType.username ? 'ParticipantLogin.Username' : ''));
        this.validationError = this.formLogin.value.login === LoginType.mobile ? 'ParticipantLogin.MobileNoRequired'
            : (this.formLogin.value.login === LoginType.email ? 'ParticipantLogin.EmailIdRequired'
                : (this.formLogin.value.login === LoginType.username ? 'ParticipantLogin.UsernameRequired' : ''));

        this.formLogin.get('otp').setValue(false);
        this.passwordLable = 'ParticipantLogin.Password';
        this.passwordErrorMessage = 'ParticipantLogin.PasswordRequired';
        this.isResendOTP = false;
        this.formLogin.controls['username'].enable();
    }

    calculateDateDifference(startDate: Date, endDate: Date) {
        var startDateUtc = Date.UTC(startDate.getFullYear(), startDate.getMonth(), startDate.getDate(), startDate.getHours(), startDate.getMinutes(), startDate.getSeconds());
        var endDateUtc = Date.UTC(endDate.getFullYear(), endDate.getMonth(), endDate.getDate(), endDate.getHours(), endDate.getMinutes(), endDate.getSeconds());
        const expiryTime: number = ((endDateUtc - startDateUtc) / 1000)
        this.expiryMinutes = Math.floor(expiryTime / 60);
        this.expirySeconds = (expiryTime - this.expiryMinutes * 60);
    }

    onLoginSucceeded(result) {
        if (result.isAdmin) {
            window.location.href = environment.adminUrl + '/home';
        }
        else {

        }

        var data = {
            'userAgent': window.navigator.userAgent,
            'browserName': this.getBrowserName(),
            'browserVersion': '',
            'ipAddress': '',
            'loginDateTime': new Date().toLocaleString("en-US", { timeZone: this.systemSettings.ianaTimeZone }),
            'loginType': this.formLogin.value.login.toString(),
            'loginMethod': this.isOTPEnabled === true ? LoginType.otp : LoginType.password
        }
        this.PreloginService.saveUserLoginActivityResource(data).subscribe(response => {
            this.router.navigate([`/home`]);
        });
    }

    getBrowserName(): any {

        var userAgent = window.navigator.userAgent;
        var browsers = { chrome: /chrome/i, safari: /safari/i, firefox: /firefox/i, ie: /internet explorer/i };

        for (var key in browsers) {
            if (browsers[key].test(userAgent)) {
                return key;
            }
        };
    }

    getSelfRegistrationStatus() {
        this.PreloginService.getSelfRegistrationStatus().subscribe(response => {
            var programName = sessionStorage.getItem("programName");
            if (programName === 'rapid') {
                this.isSelfRegistrationEnabled = false;
            }
            else {
                this.isSelfRegistrationEnabled = response.isEnabled
                this.isSelfRegistrationRequired = response.isEnabled ? '/account/ActivateSelfRegistration' : '/account/Activate';
            }
        });
    }

    show: boolean = false;
    password() {
        this.show = !this.show;
    }

    impersonateLogin(token: string) {
        let decodeToken = decodeURIComponent(token.split(' ').join('+'));
        this.authenticationService.impersonateLogin(decodeToken).subscribe(result => {
            this.router.navigate([`/home`]);
        });
    }

    ngOnDestroy() {
        this.onDestroy$.next();
        this.onDestroy$.complete();
    }
};